import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DangerNavbar from "components/Navbars/DangerNavbar.js";


function Tarifas() {
  const downloadPdfFromJson = async (jsonUrl, filename) => {
    const response = await fetch(jsonUrl);
    if (!response.ok) {
      throw new Error("No se pudo cargar el archivo");
    }

    const payload = await response.json();
    const binary = atob(payload.data);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: payload.contentType || "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || payload.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <DangerNavbar />
      <div className="main" style={{ marginTop: "8em" }}>
        <div className="section">
          <Container>
            <h3 className="title-uppercase text-center" style={{fontWeight:500,fontFamily: "'Noto Sans SC', sans-serif"}}>
              Tarifas
            </h3>
            <Row className="justify-content-center">
              <Col md="2">
                <center className="mt-5">
                  <a
                    href="#tarifas-2026"
                    role="button"
                    style={{textDecoration: "none !important", cursor: "pointer"}}
                    onClick={(e) => {
                      e.preventDefault();
                      downloadPdfFromJson(
                        "/tarifas-notariales-2026.json",
                        "RES-tarifas-notariales-2026-000964-6.pdf"
                      );
                    }}
                  >
                    <img
                      alt="Imagen con referencia Tarifas Notariales 2026"
                      width="80px"
                      src={require("assets/img/sections/pdf.jpg")}
                    ></img>
                    <h6 className="my-3">TARIFAS NOTARIALES 2026</h6>
                  </a>
                </center>
              </Col>
              <Col md="2">
                <center className="mt-5">
                  <a href="https://drive.google.com/file/d/1-yVGv4E9rdZjAAbnE0oBkfQRSAtRcHXu/view" style={{textDecoration: "none !important"}} target="_blank" rel="noopener noreferrer">
                    <img
                      alt="Imagen con referencia Tarifas Notariales"
                      width="80px"
                      src={require("assets/img/sections/pdf.jpg")}
                    ></img>
                    <h6 className="my-3">TARIFAS DTR SDR</h6>
                  </a>
                </center>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Tarifas;
